<template>
  <div class="winners-2019-qualification-winners-card">
    <h3 class="winners-2019-qualification-winners-card__title">
      {{ number }} квалификация
    </h3>
    <div class="winners-2019-qualification-winners-card__body">
      <div class="winners-2019-qualification-winners-card__winner-wrapper">
        <Winners2019QualificationWinner :prize="prize_1" :user="winner_1" />
      </div>
      <div class="winners-2019-qualification-winners-card__winner-wrapper">
        <Winners2019QualificationWinner :prize="prize_2" :user="winner_2" />
      </div>
    </div>
  </div>
</template>

<script>
import Winners2019QualificationWinner from "./Winners2019QualificationWinner";

export default {
  name: "Winners2019QualificationWinnersCard",
  props: {
    number: [Number, String],
    prize_1: Object,
    winner_1: Object,
    prize_2: Object,
    winner_2: Object
  },
  components: {
    Winners2019QualificationWinner
  }
};
</script>

<style lang="scss">
.winners-2019-qualification-winners-card {
  padding: 40px 20px;
  border-radius: 6px;
  background: linear-gradient(180deg, rgba(#171a29, 0.8), rgba(#071c52, 0.8));
  font-family: "Montserrat";
  text-align: center;

  &__title {
    text-shadow: 0px 3px 40px #7923a6, 0px 4px 20px #000000;
    font-weight: 900;
    font-size: 30px;
    margin-bottom: 10px;
  }

  &__body {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  &__winner-wrapper {
    padding: 10px 25px;
  }

  @include breakpoint("xs-only") {
    padding: 30px 15px;
    &__title {
      font-size: 24px;
    }
  }
}
</style>
